import focusElement from './focus-element';

/** Moves focus to an element matching `selector` inside of `ref` */
export default function(ref = {}, selector = '') {
  const element = ref.current;
  if (element && typeof element.querySelector === 'function') {
    focusElement(element.querySelector(selector));
  }
}
